import CustomElement from '../core/custom.js'
import Plyr from 'plyr'

import 'plyr/dist/plyr.css'

export default window.customElements.define(
  'plyr-video',
  class extends CustomElement {
    constructor() {
      super()

      this.events = {
        ...this.events,
        click: 'onClickCapture'
      }
    }

    connectedCallback() {
      super.connectedCallback()

      this.$video = this.querySelector('.js-plyr-video-video')

      const autoplay = this.dataset.autoplay == 'true'

      this.player = new Plyr(this.$video, {
        autoplay,
        muted: true,
        controls: ['play', 'progress', 'mute'],
        i18n: {
          mute: 'sound off',
          unmute: 'sound on'
        }
      })

      autoplay &&
        this.player.on('ready', () => {
          this.player.play()
        })

      this.player.on('loadedmetadata', () => {
        const { videoWidth, videoHeight } = this.player.media

        this.style.setProperty('--ratio', `${videoWidth}/${videoHeight}`)
      })
    }

    disconnectedCallback() {
      super.disconnectedCallback()

      this.player.destroy()
    }

    onClickCapture(e) {
      e.stopPropagation()
    }

    pause() {
      this.player.pause()
    }
  }
)
